import useMutationApi from 'src/api/useMutationApi';

export interface ProcessOCRResultDTO {
  id: string;
  documentId: string;
  vendor: string;
  modelVersion: string;
  promptVersion: string | null;
  customInstructions: string | null;
  status: string;
  extractedResult: Record<string, unknown> | null;
  processingMetadata: Record<string, unknown> | null;
  error: string | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface ProcessDocumentOCRRequest {
  customInstructions?: string;
  responseFormat?: 'text' | 'json' | 'mixed';
  maxPages?: number;
  imageQuality?: 'low' | 'medium' | 'high';
}

export interface ProcessDocumentOCRResponse {
  data: ProcessOCRResultDTO;
}

const useProcessDocumentOCR = (documentId: string) => {
  return useMutationApi<ProcessDocumentOCRRequest, ProcessDocumentOCRResponse>({
    endpoint: `core/documents/${documentId}/ocr`,
    method: 'POST',
    showSuccessToast: false,
  });
};

export default useProcessDocumentOCR;
